/**
 * Build-time configuration. Mirrors the mobile app's `@/lib/config`, but reads
 * Vite's `import.meta.env` instead of Expo's `Constants.expoConfig.extra`.
 *
 * The API base URL points at the SAME Go service the mobile app uses — this app
 * adds no backend of its own. Remember to add this origin to the API's
 * `CORS_ORIGINS` (default dev origin: http://localhost:4000).
 */
export const API_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:8080/api/v1';

export const GOOGLE_WEB_CLIENT_ID = import.meta.env.VITE_GOOGLE_WEB_CLIENT_ID ?? '';

/** Posts' media_url (and similar) come back as an API-relative path (e.g.
 * "/blobs/{id}") — resolve it against API_URL before handing it to an <img>,
 * <video> or a download, all of which need an absolute URL. */
export function resolveMediaUrl(url?: string): string | undefined {
  if (!url) return undefined;
  return url.startsWith('http') ? url : `${API_URL}${url}`;
}
